import React, { useState, useEffect } from "react";
import "./SidePanel.css";

const SidePanel = ({ applyFilters, isSidebarOpen, toggleSidebar }) => {
  const [countries, setCountries] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState("");
  const [selectedSatellite, setSelectedSatellite] = useState("Aqua");
  const [selectedInstrument, setSelectedInstrument] = useState("MODIS");
  
  // Fetch country data from NASA FIRMS API
  useEffect(() => {
    fetch("https://firms.modaps.eosdis.nasa.gov/api/countries/?format=json")
      .then((response) => response.json())
      .then((data) => {
        setCountries(
          data.map((country) => ({
            countryName: country.name,
            countryCode: country.abreviation, 
          }))
        );
      })
      .catch((error) => console.error("Error fetching countries:", error));
  }, []);

  const handleApplyFilters = () => {
    if (!selectedCountry || !selectedSatellite || !selectedInstrument) {
      alert("Please select all filters before applying.");
      return;
    }

    applyFilters({
      country: selectedCountry,
      satellite: selectedSatellite,
      instrument: selectedInstrument,
    });
  };

  return (
    <div className={`side-panel ${isSidebarOpen ? "open" : ""}`}>
      <button className="sidebar-toggle" onClick={toggleSidebar}>
        <svg
          fill="#fe1818"
          height="24px"
          width="24px"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          className={isSidebarOpen ? "rotate-180" : ""}
        >
          <polygon points="6.8,23.7 5.4,22.3 15.7,12 5.4,1.7 6.8,0.3 18.5,12" />
        </svg>
      </button>

      <div className="side-panel-container">
        <h3>Filters</h3>

        <label>
          Select Country:
          <select
            value={selectedCountry}
            onChange={(e) => setSelectedCountry(e.target.value)}
          >
            <option value="IND" selected>India</option>
            {countries.map((country) => (
              <option key={country.countryCode} value={country.countryCode}>
                {country.countryName}
              </option>
            ))}
          </select>
        </label>

        <label>
          Select Satellite:
          <select
            value={selectedSatellite}
            onChange={(e) => setSelectedSatellite(e.target.value)}
          >
            <option value="Aqua">Aqua</option>
            <option value="Terra">Terra</option>
            <option value="Aura">Aura</option>
          </select>
        </label>

        <label>
          Select Instrument:
          <select
            value={selectedInstrument}
            onChange={(e) => setSelectedInstrument(e.target.value)}
          >
            <option value="MODIS">MODIS</option>
            <option value="VIIRS">VIIRS</option>
            <option value="OMI">OMI</option>
          </select>
        </label>

        <button onClick={handleApplyFilters}>Apply Filters</button>
      </div>
    </div>
  );
};

export default SidePanel;
